<template>
    <div class="d-flex flex-column overflow-hidden h-100">
        <vue-custom-scrollbar
            class="app-content-padding flex-grow-1 overflow-hidden h-100"
        >
            <div class="demo-spin-article">
                <div class="row">
                    <div class="col-md-12">
                        <ts-panel>
                            <ts-panel-wrapper>
                                <loan-tobe-collect
                                    v-model="model"
                                    :validation="errors"
                                    ref="repaymentInfo"
                                />
                            </ts-panel-wrapper>
                        </ts-panel>
                    </div>
                </div>
            </div>
            <Spin size="large" fix v-if="loading"> </Spin>
        </vue-custom-scrollbar>
        <div
            id="footer"
            class="app-footer m-0 tw-flex tw-justify-end tw-space-x-2 tw-sh"
            style="background-color: #e9ecef"
        >
            <ts-button
                @click.prevent="$router.push({ name: 'loan-repayment' })"
                class="btn-gray"
            >
                {{ $t("cancel") }}</ts-button
            >
            <ts-button
                color="primary"
                outline
                :waiting="waiting_new"
                :disabled="waiting"
                @click.prevent="onSaveAddNew"
            >
                {{ $t("saveAddNew") }}</ts-button
            >
            <ts-button
                color="primary"
                :waiting="waiting"
                :disabled="waiting_new"
                @click.prevent="onSave"
            >
                {{ $t("save") }}</ts-button
            >
        </div>
    </div>
</template>

<script>
import AppOptions from "@/config/AppOptions.vue";
import { mapActions } from "vuex";
import { Errors } from "form-backend-validation";
import moment from "moment";
import LoanTobeCollect from "../components/loan-tobe-collect.vue";

export default {
    name: "loanRepaymentCreate",
    components: {
        LoanTobeCollect
    },
    data() {
        return {
            loading: false,
            waiting: false,
            show_alert: false,
            waiting_new: false,
            errors: new Errors(),
            model: {
                actual_payment_date: moment().format("DD-MM-YYYY"),
                payment_type: 1
            },
            dataInput: [],
            successCreate: []
        };
    },
    created() {
        AppOptions.appContentFullHeight = true;
        AppOptions.appContentClass = "p-0";
    },
    methods: {
        ...mapActions("creditOperation/loanRepayment", ["getLoanType"]),
        async fetchResource() {
            this.loading = true;
            await this.$refs.repaymentInfo.loadLoanDisbursement();
            this.loading = false;
        },
        async onSaveAddNew() {
            this.dataInput = this.$refs.repaymentInfo.loanDisbursementsList
                .filter(loan => loan.amount_paid > 0)
                .map(el => ({
                    loan_id: el.loan_id,
                    actual_payment_date: this.model.actual_payment_date,
                    cycle_payment_date: el.cycle_payment_date,
                    amount_paid: el.amount_paid,
                    penalty_waive: null,
                    input_source: "W",
                    payment_type: this.model.payment_type,
                    device_info: null,
                    ref_voucher: el.ref_voucher
                }));
            this.errors = new Errors();
            this.waiting_new = true;
            this.successCreate = [];
            this.show_alert = false;
            for (const item of this.dataInput) {
                await this.$store
                    .dispatch("creditOperation/loanRepayment/store", item)
                    .then(() => {
                        this.successCreate.push(item);
                    })
                    .catch(error => {
                        this.show_alert = true;
                        this.waiting_new = false;
                        this.errors = new Errors(error.errors);
                        this.notice({ type: "error", text: error.message });
                    });
                if (this.show_alert) {
                    break;
                }
            }
            this.successCreate.forEach(async el => {
                await this.dataInput.splice(this.dataInput.indexOf(el), 1);
            });
            this.waiting_new = false;
            if (this.dataInput.length == 0) {
                this.notice({
                    type: "success",
                    text: "Action completed successfully!"
                });
                this.clearInput();
                this.$refs.repaymentInfo.loadLoanDisbursement();
            }
        },
        async onSave() {
            this.dataInput = this.$refs.repaymentInfo.loanDisbursementsList
                .filter(loan => loan.amount_paid > 0)
                .map(el => ({
                    loan_id: el.loan_id,
                    actual_payment_date: this.model.actual_payment_date,
                    cycle_payment_date: el.cycle_payment_date,
                    amount_paid: el.amount_paid,
                    penalty_waive: null,
                    input_source: "W",
                    payment_type: this.model.payment_type,
                    device_info: null,
                    ref_voucher: el.ref_voucher
                }));
            this.errors = new Errors();
            this.waiting = true;
            this.successCreate = [];
            this.show_alert = false;
            for (const item of this.dataInput) {
                await this.$store
                    .dispatch("creditOperation/loanRepayment/store", item)
                    .then(() => {
                        this.successCreate.push(item);
                    })
                    .catch(error => {
                        this.show_alert = true;
                        this.waiting = false;
                        this.errors = new Errors(error.errors);
                        this.notice({ type: "error", text: error.message });
                    });
                if (this.show_alert) {
                    break;
                }
            }
            this.successCreate.forEach(async el => {
                await this.dataInput.splice(this.dataInput.indexOf(el), 1);
            });
            this.waiting = false;
            if (this.dataInput.length == 0) {
                this.notice({
                    type: "success",
                    text: "Action completed successfully!"
                });
                this.clearInput();
                this.$router.push({ name: "loan-repayment" });
            }
        },
        clearInput() {
            this.errors = new Errors();
            (this.model.actual_payment_date = moment().format("DD-MM-YYYY")),
                (this.model.cycle_payment_date = moment().format("DD-MM-YYYY")),
                (this.model.loan_id = null),
                (this.model.amount_paid = null),
                (this.model.penalty_waive = null),
                (this.model.payment_type = 1),
                (this.model.input_source = "W"),
                (this.$refs.repaymentInfo.repaymentItems = []),
                this.$store.commit("creditOperation/loanRepayment/RESET_STATE");
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "LOAN REPAYMENT",
                desc: not.text
            });
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchResource();
        });
    },
    beforeRouteLeave(to, from, next) {
        AppOptions.appContentFullHeight = false;
        AppOptions.appContentClass = "";
        this.$store.commit("creditOperation/loanRepayment/RESET_STATE");
        this.$store.commit("creditOperation/loanRepayment/CLEAR_RESOURCES");
        next();
    }
};
</script>
